import { observer } from "mobx-react-lite";
import { ConfirmEmptyTrashModal } from "@/pages/trash/confirm-empty-trash-modal";
import { DeleteNotesPermanentlyModal } from "@/components/modal/delete-notes-permanently";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { TrashPageList } from "@/pages/trash/trash-page-list";
import {
  MDSPanelHeader,
  MDSTextVariant,
  MDSPanelHeaderSlotName,
  MDSPanelHeaderButtonGroup,
  MDSIconButton,
  MDSTooltip,
  MDSTooltipPlacement,
  MDSText,
  MDSBanner,
  MDSBannerKind,
  MDSIconButtonSize,
  MDSIconKind,
  MDSPanelContainer,
} from "@/mds";

interface TrashPageProps {}

export const TrashPage = observer<TrashPageProps>(function TrashPage() {
  const page = useTabPageStore("trashPage");
  page.listState.useListStateEffects();

  return (
    <>
      <DeleteNotesPermanentlyModal store={page.deleteNotePermanentlyModal} />
      <ConfirmEmptyTrashModal />

      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Trash
        </MDSText>
        <MDSPanelHeaderButtonGroup slot={MDSPanelHeaderSlotName.Actions}>
          <MDSTooltip config={{ label: "Empty trash", placement: MDSTooltipPlacement.Top }}>
            <MDSIconButton
              iconKind={MDSIconKind.Trash}
              onClick={page.openConfirmModal}
              size={MDSIconButtonSize.Medium}
            />
          </MDSTooltip>
        </MDSPanelHeaderButtonGroup>
      </MDSPanelHeader>
      <MDSBanner
        kind={MDSBannerKind.Default}
        iconKind={MDSIconKind.InfoCircle}
        message="Notes in trash are deleted after 30 days"
      />
      <MDSPanelContainer>
        <TrashPageList />
      </MDSPanelContainer>
    </>
  );
});
